/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyboxDiamond.vue?vue&type=template&id=7961c888&scoped=true"
import script from "./popLuckyboxDiamond.vue?vue&type=script&lang=js"
export * from "./popLuckyboxDiamond.vue?vue&type=script&lang=js"
import style0 from "./popLuckyboxDiamond.vue?vue&type=style&index=0&id=7961c888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7961c888",
  null
  
)

export default component.exports